module.exports = __webpack_public_path__ + "6e6793b7e1241bff8e2bb12c76f988e1.svg";